import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Docente de Comunicación | Lima, Perú',
  text: 'El material sobre algoritmos y redes sociales le cambió la cara a mis alumnos. Por fin entienden por qué ven siempre lo mismo en TikTok y cómo salir de la cámara de eco. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor de Medios | Montevideo, Uruguay',
  text: 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen desde cero bajo presión. Salgo de cada trimestre con la satisfacción de tener todo resuelto.'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  role: 'Docente de Comunicación Social | Caracas, Venezuela',
  text: 'El taller del Framing transformó el grupo más difícil que tenía. Lo aplico en la primera semana y mis alumnos nunca más ven las noticias de la misma manera. Eso no lo encontré en ningún otro material.'
}, {
  initials: 'AM',
  name: 'Ana M.',
  role: 'Docente universitaria | Buenos Aires, Argentina',
  text: 'La guía de producción de podcasts me devolvió el tiempo de planificación. Antes perdía horas buscando cómo armar un proyecto de audio. Ahora entrego la plantilla, los alumnos la completan y graban el mismo día.'
}, {
  initials: 'SR',
  name: 'Sebastián R.',
  role: 'Profesor de Comunicación Digital | Quito, Ecuador',
  text: 'El manual de ética y ciberciudadanía fue una revelación. Mis alumnos hacen preguntas muy complejas sobre privacidad y algoritmos y ahora tengo siempre los marcos correctos para responder. Eso cambió completamente mi seguridad en el aula.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="text-center mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-67">
            Lo que dicen los docentes que ya tienen su Mega Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69">
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-70" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" />)}
              </div>

              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-73">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-75">
                  {t.initials}
                </div>
                <div data-id="element-76">
                  <div className="font-bold text-white" data-id="element-77">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-78">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}